export default __webpack_public_path__ + "static/media/backgroundmobile.0453fbd6.png";